export default {"src":"/_next/static/media/analysis.d98c37fe.svg","height":51,"width":50};